import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;

	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)
	const base641 = await pathToBase64(`/images/custom/${data?.customTheme}/base64-1.png`);

	return {
		"id": id,
		"elements": [
			{
				"type": "shape",
				"id": "ukzsVC0OvY",
				"width": 705.86,
				"height": 131.71,
				"left": 294.14,
				"top": 430.8,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "#bd150a",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#254061",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Calibri;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "uBeg4QlMpG",
				"width": 294.14,
				"height": 131.71,
				"left": 0,
				"top": 430.79,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "#d3190b",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#254061",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Calibri;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "07IXWVyrEN",
				"src": base641,
				"width": 846.8,
				"height": 350.35,
				"left": 79.27,
				"top": 102.28,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": true,
				"flipV": false
			},
			{
				"type": "text",
				"id": "xxkrGZCbOM",
				"width": 632.11,
				"height": 102.625,
				"left": 139.77,
				"top": 192.83,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"\"><strong><span style=\"font-size: 81.63px;\"><span style=\"font-family: Arial;\"><span style=\"color: rgba(255,255,255,1);\">谢谢您的观看</span></span></span></strong></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "j2QDIp_i4d",
				"width": 211.97,
				"height": 267.90625,
				"left": 729.21,
				"top": 137.66397273539934,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"\"><em><strong><span style=\"font-size: 244.9px;\"><span style=\"font-family: Arial;\"><span style=\"color: rgba(255,255,255,1);\">”</span></span></span></strong></em></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "6IfFxsRp4J",
				"width": 214.62,
				"height": 40.40625,
				"left": 79.51,
				"top": 487.69,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"\"><span style=\"font-size: 20.41px;\"><span style=\"font-family: Arial;\">汇报人：ChatGpt</span></span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "HFTlrtuWHk",
				"width": 128.53,
				"height": 40.40625,
				"left": 79.51,
				"top": 46.23,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: left;\"><span style=\"color: #BD150A;font-size: 20.41px;font-family: Arial;font-weight: bold;\">&nbsp;</span><span style=\"color: #BD150A;font-size: 20.41px;font-family: Arial;font-weight: bold;\">LOGO</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "6xo_JEelLn",
				"width": 27.87,
				"height": 27.87,
				"left": 893.57,
				"top": 44.6,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "#bd150a",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#254061",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Calibri;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			}
		],
		background
	};

}